import { createSlice } from '@reduxjs/toolkit'
import { logout } from './AuthSlice'
import { getCompanies } from './CompanySlice'
import { getPeople } from './PeopleSlice'
import { getLpns } from './LpnSlice'

const initialState = {
  showAdminBar: false,
  showAdminControl: false,
  adminListReload: 0,
  adminListLoading: false,
}

const adminSlice = createSlice({
  name: 'admin',
  initialState,
  reducers: {
    setAdminState: (state, action) => {
      state[action.payload.field] = action.payload.value
    },
    toggleAdminBar: (state, action) => {
      const show = !state.showAdminBar
      if (!show) {
        state.showAdminControl = false
      }
      state.showAdminBar = show
    },
    setAdminControl: (state, action) => {
      state.showAdminControl = action.payload
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCompanies.fulfilled, (state, action) => {
        state.adminListLoading = false
      })
      .addCase(getPeople.fulfilled, (state, action) => {
        state.adminListLoading = false
      })
      .addCase(getLpns.fulfilled, (state, action) => {
        state.adminListLoading = false
      })
      .addCase(logout, (state, action) => {
        return { ...initialState }
      })
  },
})

export const { setAdminState, toggleAdminBar, setAdminControl } = adminSlice.actions
export default adminSlice.reducer
